export const actionTypes = {
    APP_SETTINGS_SET: "APP_SETTINGS_SET"
};

export const actionCreators = {
    set: (appSettings: any) => ({
        type: actionTypes.APP_SETTINGS_SET,
        payload: { appSettings }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
